import styled from 'styled-components';
import {injectSafeTop} from 'ui/theme';

export const Wrapper = styled.div`
  ${injectSafeTop('padding')}
`;
